module.exports = __webpack_public_path__ + "img/nr.3db63999.svg";